import * as React from 'react'
import * as PropTypes from 'prop-types'
import * as oauthHandshake from '../oauthHandshake'
import {Spinner} from "../../../components";
import LoginStore from '../LoginStore';
import ThemeStore from '../../config/ThemeStore';
import {observer} from 'mobx-react';
import FullPageSpinner from "./FullPageSpinner";

/** call back view that will accept external credentials for saving to the backend after logging in from a 3rd party.
 * Expects a parent window to exist. See oauthHandshake for more details */
export const OAuthCallbackView = observer(class OAuthCallbackView extends React.Component {

  static propTypes = {
    // react-router props
    match: PropTypes.shape({
      params: PropTypes.shape({
        provider: PropTypes.string
      })
    }),
    location: PropTypes.shape({
      params: PropTypes.string,
    }),
    history: PropTypes.shape({
      push: PropTypes.func,
    })
  }


  state = {
    message: "Completing Authentication",
    loading: true
  }

  cancelRedirect;
  componentDidMount() {
    oauthHandshake.onCallbackReceived(this.props.match.provider)
      .then(done => {
        this.setState({
          message: "Successfully completed",
          loading: false
        })
        window.focus();
      })
      .catch(ex => {
        this.setState({
          loading: false,
          message: "Oops! An error occurred"
        })

      })
      .finally(() => {
        this.cancelRedirect = setTimeout(() => this.props.history.push("/"), 30000)
      })
  }

  componentWillUnmount() {
    clearTimeout(this.cancelRedirect)
  }


  render() {
    return <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }}><div className="m-auto">
      { this.state.loading || !ThemeStore.isLoaded && <FullPageSpinner /> }
      { ThemeStore.isLoaded && <h4>{this.state.message}</h4> }
    </div></div>
  }


});
